module.exports = __webpack_public_path__ + "img/BARUDI_GIF.gif";